import {
  Directive, ElementRef, forwardRef, HostListener, Input, isDevMode, Optional, Renderer2, Self,
} from '@angular/core';
import {
  AbstractControl, DefaultValueAccessor, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn,
} from '@angular/forms';

@Directive({
  selector: 'input[lmsNoSpecials]',
  standalone: true,
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => LMS_NoSpecialsDirective),
      multi: true,
    },
  ],
})
export class LMS_NoSpecialsDirective implements Validator {
  @Input() allowPaste:boolean = false;
  @Input() checkPastedValue:boolean = true;
  @Input() UpperCaseValue:boolean = false;
  @Input() AllowNumbers: boolean = true;

  constructor(
    private element: ElementRef<HTMLInputElement>,
    private renderer: Renderer2,
    @Optional() @Self() private valueAccessor: DefaultValueAccessor
  ) {}

  private _validatorChangeFn: () => void = () => {};

  private LMS_NoSpecialsValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const inputValue = control.value;
    const sanitizedValue = this.sanitizeValue(inputValue);

    if (inputValue !== sanitizedValue) {
      return { NoSpecials: true };
    }

    return null;
  };

  validate(control: AbstractControl): ValidationErrors | null {
    if (control && control.value) {
      return this.LMS_NoSpecialsValidator(control);
    }
    return null;
  }

  registerOnValidatorChange(fn: () => void): void {
    this._validatorChangeFn = fn;
  }

  private sanitizeValue(value: string): string {
    if(!this.AllowNumbers) {
      return value.replace(/[^a-zA-Z _-]/g, '');
    }

    return value.replace(/[^a-zA-Z0-9 _-]/g, '');
  }

  private setSanitisedValue(value?: string): void {
    if (!value && this.element.nativeElement) {
      value = this.element.nativeElement.value;
    }

    let sanitizedValue = this.sanitizeValue(value || '');
    if (this.UpperCaseValue) {
      sanitizedValue = sanitizedValue.toUpperCase();
    }

    if(sanitizedValue === this.element.nativeElement.value){
      return;
    }

    if (this.valueAccessor) {
      this.valueAccessor.writeValue(sanitizedValue);
    } else {
      this.renderer.setProperty(this.element.nativeElement, 'value', sanitizedValue);
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: InputEvent): void {

    if(event.inputType === 'insertFromPaste' && (!this.allowPaste && !isDevMode())){
      event.preventDefault();
      return;
    }

    const val = event.target as HTMLInputElement;
    let trimmedValue = val.value ?? '';

    if(event.inputType === 'insertFromPaste') {
      trimmedValue = trimmedValue.trimStart().trimEnd();
    }

    this.setSanitisedValue(trimmedValue);
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    if (!this.allowPaste && !isDevMode()) {
      event.preventDefault();
    }

    // const clipboardData = event.clipboardData?.getData('text/plain') || '';
    // if (!this.checkPastedValue) {
    //   event.preventDefault();
    // }

    // if (clipboardData !== '') {
    //   this.setSanitisedValue(clipboardData);
    // }
  }
}
